export const DEFAULT_CHANGE_TYPES = {
  hiring: 'hiring',
  termination: 'termination',
  contract: 'contract',
  contract_reactivation: 'contract_reactivation',
}

export const EMPLOYEE_CHANGE_TYPES = {
  address: 'address',
  bank: 'bank',
  cost_center: 'cost_center',
  gender: 'gender',
  hiring: 'hiring',
  id: 'id',
  irpf: 'irpf',
  legal_entity: 'legal_entity',
  nationality: 'nationality',
  name: 'name',
  phone_number: 'phone_number',
  residence: 'residence',
  tax_id: 'tax_id',
  termination: 'termination',
  workplace: 'workplace',
  email: 'email',
  team: 'team',
}

export const LEAVE_CHANGE_TYPES = {
  sick: 'sick',
  parental: 'parental',
  custom_leave: 'custom-leave',
}

export const CONTRACT_CHANGE_TYPES = {
  contract: 'contract',
  contract_reactivation: 'contract_reactivation',
}

export const COST_CENTER_CHANGE_TYPES = {
  cost_center: 'cost_center',
}

export const MANUAL_CHANGE_TYPES = {
  manual_incidence: 'manual_incidence',
}

export const INCIDENCE_TYPES = {
  ...EMPLOYEE_CHANGE_TYPES,
  ...LEAVE_CHANGE_TYPES,
  ...CONTRACT_CHANGE_TYPES,
  ...COST_CENTER_CHANGE_TYPES,
  ...MANUAL_CHANGE_TYPES,
}
